<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Catálogo de rutas activas. Crea, edita o desactiva rutas;
                asigna vendedor, territorio, áreas y horarios. Úsalo para
                dejar listas las rutas que operan cada día.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Rutas
          </h2>
        </div>



        
        <div class="text-sm text-secondary font-medium tracking-tight">
          Permite monitorear...
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <app-status-filters [selectedStatuses]="selectedStatuses"
            [modeTree]="modeTree"
            [showStatus]="[1,0]" 
            [typeFilter]="'master'"
            [showTreeMode]="true"
            (selectionFilterApply)="findAllWithCount()"
            (selectionFilterApplyTree)="onChangeEmissionPointTree($event)">
          </app-status-filters>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Rutas</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">

          <!-- <mat-slide-toggle style="margin-top: 0.7em; margin-right: 2em;" color="primary" [(ngModel)]="modeTree"
            (click)="onChangeEmissionPointTree()">
            Modo Árbol
          </mat-slide-toggle> -->
          <button
            *canPermissionsOnly="PERMISSIONS_ASSOCIATIONS.VIEW"
            class="ml-3 hidden sm:inline-flex"
            mat-flat-button
            [color]="'primary'"
            (click)="openRelationshipsModal()"
          >
            <mat-icon class="icon-size-5">link</mat-icon>
            <span class="ml-2">Relaciones de ruta</span>
          </button>
          <button *canPermissionsOnly="PERMISSIONS_TRIPS.VIEW" class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="openRoutesModal()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
            <span class="ml-2">Viajes asociados</span>
          </button>
          <button *canPermissionsOnly="PERMISSIONS.EXPORT" class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>

          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Glosario">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:map" style="color: #008000;"></mat-icon>
              <span>URBANA</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:map" style="color: #0000ff;"></mat-icon>
              <span>FORÁNEA</span>
            </button>
          </mat-menu>

          <!-- Client Route Locator button -->
          <button *canPermissionsOnly="PERMISSIONS_ASSOCIATIONS.BUSINESS_PARTNER" mat-icon-button color="primary" (click)="openClientRouteLocator()"
            matTooltip="Localizador de Clientes">
            <mat-icon svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
          </button>

          <!-- Add button (only icon) -->
          <button *canPermissionsOnly="PERMISSIONS.CREATE" mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
          <div style="display:inline-flex">
            <button mat-icon-button [matMenuTriggerFor]="importMenu" matTooltip="Importar archivo">
              <mat-icon>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                  <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                    stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                    font-family="none" font-weight="none" font-size="none" text-anchor="none"
                    style="mix-blend-mode: normal">
                    <g transform="scale(5.12,5.12)">
                      <path
                        d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z">
                      </path>
                    </g>
                  </g>
                </svg>
              </mat-icon>
            </button>
            <mat-menu #importMenu="matMenu">
              <button *canPermissionsOnly="PERMISSIONS.EXPORT" mat-menu-item (click)="downloadSubRouteTemplate()">
                <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                <span>Descargar Plantilla</span>
              </button>
              <app-import-button [config]="routeTerritoryImportConfig" [buttonText]="'Importar Archivo'" [disabled]="!(PERMISSIONS.UPLOAD | hasPermission)"
                [variant]="{ type: 'mat-menu', color: '' }">
              </app-import-button>
            </mat-menu>

          </div>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div *ngIf="!modeTree" class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort [trackBy]="trackByFn">
              <!-- Código -->
              <!-- <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Código</th>
                <td mat-cell *matCellDef="let subRoute" class="pl-10 text-left">{{ subRoute.code }}</td>
              </ng-container> -->

              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Nombre
                </th>
                <td mat-cell *matCellDef="let subRoute" class="text-sm leading-tight">
                  <div *ngIf="getCode(subRoute) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ subRoute.name }}
                </td>
              </ng-container>

              <!-- Responsable / Usuario -->
              <ng-container matColumnDef="responsibleWithUser">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Responsable
                </th>
                <td mat-cell *matCellDef="let subRoute" class="text-sm uppercase leading-tight">
                  <!-- Responsable -->
                  <div>
                    <ng-container *ngIf="getCode(subRoute?.responsibleBusinessPartner) as code">
                      <b>{{ code }}</b><br>
                    </ng-container>
                    {{ subRoute.responsibleBusinessPartner?.name ?? '-' }}
                  </div>

                  <!-- Usuario debajo -->
                  <div class="mt-1 text-xs">
                    <b>Usuario: </b>{{ subRoute.mainCollaborator?.businessPartner?.name ?? '-' }}
                  </div>
                </td>
              </ng-container>

              <!-- Usuario -->
              <ng-container matColumnDef="mainCollaborator">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-sm">
                  Usuario
                </th>
                <td mat-cell *matCellDef="let subRoute" class="text-sm uppercase">
                  {{subRoute.mainCollaborator?.businessPartner?.name ?? '-' }}
                </td>
              </ng-container>

              <!-- Responsable -->
              <ng-container matColumnDef="responsibleBusinessPartner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-sm">
                  Responsable
                </th>
                <td mat-cell *matCellDef="let subRoute" class="text-sm uppercase leading-tight">
                  <span class="f-10">
                    <ng-container *ngIf="getCode(subRoute?.responsibleBusinessPartner) as code">
                      <b>{{ code }} </b><br>
                    </ng-container>
                  </span>
                  {{subRoute.responsibleBusinessPartner?.name ?? '-' }}
                </td>
              </ng-container>

              <!-- Territorio -->
              <ng-container matColumnDef="routes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-sm"> Territorios </th>
                <td mat-cell *matCellDef="let subRoute" class="ellipsis text-sm uppercase"
                  [matTooltip]="subRoute.routes.length > 1 ? getRouteNames(subRoute.routes) : null"
                  matTooltipPosition="above">
                  <span *ngFor="let d of subRoute.routes; let i = index">
                    {{d.name}}
                    <span *ngIf="i != (subRoute.routes.length -1 );">,</span>
                  </span>
                </td>
              </ng-container>

              <!-- Area de Rutas -->
              <ng-container matColumnDef="routeAreas">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-sm">Oficina de venta</th>
                <td mat-cell *matCellDef="let subRoute" class="ellipsis text-sm uppercase">
                  {{subRoute?.salesOffice?.name}}
                </td>
              </ng-container>

                <!-- Grupo de Rutas -->
              <ng-container matColumnDef="group">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-sm">Grupo de Rutas</th>
                <td mat-cell *matCellDef="let subRoute" class="ellipsis text-sm uppercase">
                  {{subRoute?.routeGroup?.name}}
                </td>
              </ng-container>

              <!-- Tipo -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-sm no-padding-cell">
                </th>
                <td mat-cell *matCellDef="let subRoute" class="text-left uppercase no-padding-cell">
                  <button mat-icon-button *ngIf="subRoute.type === subRouteTypeEnum.URBAN"
                    (click)="openSubRoutePartners(subRoute)"
                    [matTooltip]="subRoute.type ? getSubRouteTypeName(subRoute.type) : null">
                    <mat-icon svgIcon="heroicons_outline:map" style="color: #008000;"></mat-icon>
                  </button>

                  <button mat-icon-button *ngIf="subRoute.type === subRouteTypeEnum.FOREIGN"
                    (click)="openSubRoutePartners(subRoute)"
                    [matTooltip]="subRoute.type ? getSubRouteTypeName(subRoute.type) : null">
                    <mat-icon svgIcon="heroicons_outline:map" style="color: #0000ff;"></mat-icon>
                  </button>
                </td>
              </ng-container>

              <!-- Compañía -->
              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Compañía
                </th>
                <td mat-cell *matCellDef="let subRoute" class="px-6 text-left">
                  <div>
                    <b>{{ subRoute.company.code }}</b>
                  </div>
                  <div>{{ subRoute.company.name }}</div>
                </td>
              </ng-container>



              <ng-container matColumnDef="frecuency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left no-padding-cell">
                </th>
                <td mat-cell *matCellDef="let subRoute" class="text-left no-padding-cell">
                  <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.VIEW" mat-icon-button (click)="openSubRoutePartners(subRoute)" matTooltip="Frecuencia">
                    <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                  </button>

                  <!-- <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.VIEW" mat-menu-item (click)="openFrecuenciasModal(subRoute)">
                  <mat-icon svgIcon="heroicons_outline:calendar"></mat-icon>
                </button> -->
                </td>
              </ng-container>

              <!-- Estado (mat-slide-toggle) -->
              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                  Estado
                </th>
                <td mat-cell *matCellDef="let subRoute" class="px-6 text-left">
                  <mat-slide-toggle [checked]="subRoute.statusId === 1"
                    [disabled]="!(PERMISSIONS.UPDATE | hasPermission)"
                    (change)="onStatusChange($event.checked, subRoute)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let subRoute" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <!-- Ocultado temporalmente en cortijo-qas: funcionalidad de optimizar ruta.
                    <button *canPermissionsOnly="PERMISSIONS.UPDATE" mat-menu-item (click)="openOptimizationDrawer(subRoute)">
                      <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
                      <span>Optimizar ruta</span>
                    </button>
                    -->

                    <button *canPermissionsOnly="PERMISSIONS.UPDATE" mat-menu-item (click)="openEditModal(subRoute)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>

                    <button *canPermissionsOnly="PERMISSIONS_ASSOCIATIONS.USERS_CHANGE" mat-menu-item (click)="openChangeMainCollaboratorModal(subRoute)">
                      <mat-icon svgIcon="heroicons_outline:user-circle"></mat-icon>
                      <span>Cambiar Usuario Asociado</span>
                    </button>

                    <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.VIEW" mat-menu-item (click)="openAddFrecuenciesModal(subRoute)">
                      <mat-icon svgIcon="heroicons_outline:calendar"></mat-icon>
                      <span>Frecuencias</span>
                    </button>

                    <button *canPermissionsOnly="PERMISSIONS_INTERLOCUTORS.VIEW" mat-menu-item (click)="openAddCollabModal(subRoute)">
                      <mat-icon svgIcon="heroicons_outline:user-plus"></mat-icon>
                      <span>Colaborador(es)</span>
                    </button>


                    <!--<button *canPermissionsOnly="PERMISSIONS_ITINERARY.VIEW" mat-menu-item (click)="openItineraryModal(subRoute)">
                    <mat-icon
                      svgIcon="heroicons_outline:calendar-days"
                    ></mat-icon>
                    <span>Itinerario(s)</span>
                  </button>-->

                    <!-- NUEVO -->
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY.VIEW" mat-menu-item (click)="openRoutingItineraryModal(subRoute)">
                      <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                      <span>Itinerario(s)</span>
                    </button>

                    <button *canPermissionsOnly="PERMISSIONS_DELIVERY_WINDOWS.VIEW" mat-menu-item (click)="openDeliveryTimesModal(subRoute)">
                      <mat-icon svgIcon="heroicons_outline:truck"></mat-icon>
                      <span>Vnas. Horarias de Entrega</span>
                    </button>

                    <a *canPermissionsOnly="PERMISSIONS_EMISSION_POINT.VIEW" target="_blank" [routerLink]="['/master/document/emission-point']" [queryParams]="getNavigateToEmissionPointWithSubRouteQueryParams(subRoute)" mat-menu-item>
                      <mat-icon svgIcon="heroicons_outline:building-office"></mat-icon>
                      <span>Ver Punto de Emisión</span>
                    </a>

                    <button *canPermissionsOnly="PERMISSIONS.VIEW_AUDIT_LOG" mat-menu-item (click)="openAuditLog(subRoute)">
                      <mat-icon>history</mat-icon>
                      <span>Ver log de modificaciones</span>
                    </button>
                    <button *canPermissionsOnly="PERMISSIONS.DELETE" mat-menu-item (click)="openDeleteDialog(subRoute)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
            </table>
          </div>

          <!-- Paginación -->
          <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
              [length]="totalItems" [pageSize]="pageSize" (page)="onPageChange($event)">
            </mat-paginator>
          </div>
        </div>

        <!-- Main Content (Table and Paginator) -->
        <div *ngIf="modeTree" class="flex flex-auto overflow-hidden flex-col">
          <!-- Tabla -->
          <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
            <!-- Header -->
            <div class="overflow-auto flex-1 dark:bg-gray-900">
              <table class="w-full bg-transparent" mat-table [dataSource]="dataSourceTree" matSort [trackBy]="trackByFn"
                multiTemplateDataRows>
                <!-- Tipo -->
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left no-padding-cell">
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="text-left uppercase no-padding-cell">
                    <div class="flex items-center">
                      <button mat-icon-button [style.visibility]="!subRoute?.expandable ? 'hidden' : ''"
                        [style.marginLeft.px]="subRoute?.levelTree * 10" (click)="treeControl.toggle(subRoute)">
                        <mat-icon color="primary" class="mat-icon-rtl-mirror">
                          {{treeControl.isExpanded(subRoute) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                      </button>
                      <div *ngIf="!subRoute.children || subRoute.children.length === 0">
                        <button mat-icon-button *ngIf="subRoute.type === subRouteTypeEnum.URBAN"
                          (click)="openSubRoutePartners(subRoute)"
                          [matTooltip]="subRoute.type ? getSubRouteTypeName(subRoute.type) : null">
                          <mat-icon svgIcon="heroicons_outline:map" style="color: #008000;"></mat-icon>
                        </button>

                        <button mat-icon-button *ngIf="subRoute.type === subRouteTypeEnum.FOREIGN"
                          (click)="openSubRoutePartners(subRoute)"
                          [matTooltip]="subRoute.type ? getSubRouteTypeName(subRoute.type) : null">
                          <mat-icon svgIcon="heroicons_outline:map" style="color: #0000ff;"></mat-icon>
                        </button>
                      </div>
                    </div>


                  </td>
                </ng-container>
                <!-- Código -->
                <!-- <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10 text-left">Código</th>
                    <td mat-cell *matCellDef="let subRoute" class="pl-10 text-left">{{ subRoute.code }}</td>
                  </ng-container> -->

                <!-- Nombre -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Nombre
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="text-sm leading-tight">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0 else defaultRow">
                      <div *ngIf="getCode(subRoute) as code">
                        <b class="f-10">{{ code }}</b>
                      </div>
                      {{ subRoute.name }}
                    </div>
                  </td>
                </ng-container>

                <!-- Responsable / Usuario -->
                <ng-container matColumnDef="responsibleWithUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Responsable
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="text-sm uppercase leading-tight">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0 else defaultRow">
                      <!-- Responsable -->
                      <div>
                        <ng-container *ngIf="getCode(subRoute?.responsibleBusinessPartner) as code">
                          <b>{{ code }}</b><br>
                        </ng-container>
                        {{ subRoute.responsibleBusinessPartner?.name ?? '-' }}
                      </div>

                      <!-- Usuario debajo -->
                      <div class="mt-1 text-xs text-gray-600">
                        {{ subRoute.mainCollaborator?.businessPartner?.name ?? '-' }}
                      </div>
                    </div>
                  </td>
                </ng-container>


                <!-- Usuario -->
                <ng-container matColumnDef="mainCollaborator">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Usuario
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="text-sm uppercase leading-tight">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0 else defaultRow">
                      {{subRoute.mainCollaborator?.businessPartner?.name ?? '-' }}
                    </div>
                  </td>
                </ng-container>

                <!-- Responsable -->
                <ng-container matColumnDef="responsibleBusinessPartner">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Responsable
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="text-sm uppercase leading-tight">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0 else defaultRow">
                      <span class="f-10">
                        <ng-container *ngIf="getCode(subRoute?.responsibleBusinessPartner) as code">
                          <b>{{ code }} </b><br>
                        </ng-container>
                      </span>
                      {{subRoute.responsibleBusinessPartner?.name ?? '-' }}
                    </div>
                  </td>
                </ng-container>

                <!-- Territorio -->
                <ng-container matColumnDef="routes">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ modeTree === 'salesOffice' ? 'Oficina de Venta'
                    : modeTree === 'territory' ? 'Territorio'
                    : modeTree === 'group' ? 'Grupo de Ruta'
                    : 'Territorios' }}
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="ellipsis text-sm uppercase"
                    [matTooltip]="subRoute.routes.length > 1 ? getRouteNames(subRoute.routes) : null"
                    matTooltipPosition="above">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0 else territoryInfo">
                      {{ getGroupName(subRoute) }}
                    </div>
                    <ng-template #territoryInfo>
                      <b>{{ getGroupName(subRoute) }}</b>
                    </ng-template>

                  </td>
                </ng-container>

                <!-- Area de Rutas -->
                <ng-container matColumnDef="routeAreas">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Ofi</th>
                  <td mat-cell *matCellDef="let subRoute" class="ellipsis text-sm uppercase">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0 else defaultRow">
                      {{subRoute?.salesOffice?.name}}
                    </div>
                  </td>
                </ng-container>

                     <!-- Grupo de Rutas -->
              <ng-container matColumnDef="group">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-sm">Grupo de Rutas</th>
                <td mat-cell *matCellDef="let subRoute" class="ellipsis text-sm uppercase">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0 else defaultRow">
                      {{subRoute?.routeGroup?.name}}
                    </div>
                </td>
              </ng-container>

                <!-- Compañía -->
                <ng-container matColumnDef="company">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Compañía
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="px-6 text-left">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0 else defaultRow">
                      <div>
                        <b>{{ subRoute.company.code }}</b>
                      </div>
                      <div>{{ subRoute.company.name }}</div>
                    </div>
                  </td>
                </ng-container>



                <ng-container matColumnDef="frecuency">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left no-padding-cell">
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="text-left no-padding-cell">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0">
                      <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.VIEW" mat-icon-button (click)="openSubRoutePartners(subRoute)" matTooltip="Frecuencia">
                        <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                      </button>

                      <!-- <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.VIEW" mat-menu-item (click)="openFrecuenciasModal(subRoute)">
                        <mat-icon svgIcon="heroicons_outline:calendar"></mat-icon>
                      </button> -->
                    </div>
                  </td>
                </ng-container>

                <!-- Estado (mat-slide-toggle) -->
                <ng-container matColumnDef="statusId">
                  <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                    Estado
                  </th>
                  <td mat-cell *matCellDef="let subRoute" class="px-6 text-left">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0">
                      <mat-slide-toggle [checked]="subRoute.statusId === 1"
                        [disabled]="!(PERMISSIONS.UPDATE | hasPermission)"
                        (change)="onStatusChange($event.checked, subRoute)" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </td>
                </ng-container>

                <!-- Acciones -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                  <td mat-cell *matCellDef="let subRoute" class="px-6 py-3 text-left">
                    <div *ngIf="!subRoute.children || subRoute.children.length === 0">
                      <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #actionMenu="matMenu">
                        <!-- Ocultado temporalmente en cortijo-qas: funcionalidad de optimizar ruta.
                        <button *canPermissionsOnly="PERMISSIONS.UPDATE" mat-menu-item (click)="openOptimizationDrawer(subRoute)">
                          <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
                          <span>Optimizar ruta</span>
                        </button>
                        -->

                        <button *canPermissionsOnly="PERMISSIONS.UPDATE" mat-menu-item (click)="openEditModal(subRoute)">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                          <span>Editar Registro</span>
                        </button>

                        <button *canPermissionsOnly="PERMISSIONS_ASSOCIATIONS.USERS_CHANGE" mat-menu-item (click)="openChangeMainCollaboratorModal(subRoute)">
                          <mat-icon svgIcon="heroicons_outline:user-circle"></mat-icon>
                          <span>Cambiar Usuario Asociado</span>
                        </button>

                        <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.VIEW" mat-menu-item (click)="openAddFrecuenciesModal(subRoute)">
                          <mat-icon svgIcon="heroicons_outline:calendar"></mat-icon>
                          <span>Frecuencias</span>
                        </button>

                        <button *canPermissionsOnly="PERMISSIONS_INTERLOCUTORS.VIEW" mat-menu-item (click)="openAddCollabModal(subRoute)">
                          <mat-icon svgIcon="heroicons_outline:user-plus"></mat-icon>
                          <span>Colaborador(es)</span>
                        </button>


                        <!--<button *canPermissionsOnly="PERMISSIONS_ITINERARY.VIEW" mat-menu-item (click)="openItineraryModal(subRoute)">
                          <mat-icon
                            svgIcon="heroicons_outline:calendar-days"
                          ></mat-icon>
                          <span>Itinerario(s)</span>
                        </button>-->

                        <!-- NUEVO -->
                        <button *canPermissionsOnly="PERMISSIONS_ITINERARY.VIEW" mat-menu-item (click)="openRoutingItineraryModal(subRoute)">
                          <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                          <span>Itinerario(s)</span>
                        </button>

                        <button *canPermissionsOnly="PERMISSIONS_DELIVERY_WINDOWS.VIEW" mat-menu-item (click)="openDeliveryTimesModal(subRoute)">
                          <mat-icon svgIcon="heroicons_outline:truck"></mat-icon>
                          <span>Horario(s) de Entrega</span>
                        </button>

                        <button *canPermissionsOnly="PERMISSIONS.VIEW_AUDIT_LOG" mat-menu-item (click)="openAuditLog(subRoute)">
                          <mat-icon>history</mat-icon>
                          <span>Ver log de modificaciones</span>
                        </button>
                        <button *canPermissionsOnly="PERMISSIONS.DELETE" mat-menu-item (click)="openDeleteDialog(subRoute)">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                          <span>Eliminar Registro</span>
                        </button>
                      </mat-menu>
                    </div>
                  </td>
                </ng-container>

                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTree"
                  class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

                <!-- Fila principal -->
                <tr mat-row *matRowDef="let row; columns: displayedColumnsTree"
                  [ngStyle]="{'cursor': isEditSort ? 'ns-resize' : 'null'}" class="border-b">
                </tr>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo registro de ruta</h2>
      <mat-dialog-content id="addModalContent" class="!p-0 !max-h-none">
        <form #createForm="ngForm" class="gap-y-4 flex flex-col">
          <mat-tab-group>
            <mat-tab label="Información general">
              <!-- Información Básica -->
              <div class="bg-white rounded-lg border border-gray-200 p-4">
                <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                  <mat-icon class="text-blue-600">info</mat-icon>
                  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Información Básica</h3>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label>Código Externo</mat-label>
                    <input matInput [(ngModel)]="currentCreateSubRoute.code" name="code" required />
                  </mat-form-field>
                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label>Nombre</mat-label>
                    <input matInput [(ngModel)]="currentCreateSubRoute.name" name="name" required />
                  </mat-form-field>
                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label>Tipo</mat-label>
                    <mat-select [(ngModel)]="currentCreateSubRoute.type" name="type" required>
                      <mat-option *ngFor="let type of typeList" [value]="type.value">
                        {{ type.key | transloco }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div class="col-span-1">
                    <label>Función</label>
                    <ng-select [(ngModel)]="currentCreateSubRoute.subRouteFunctionId" [items]="functionList"
                      bindLabel="name" bindValue="_id" [searchable]="true" [appendTo]="'body'"
                      placeholder="Seleccione una función de ruta" name="subRouteFunctionId"
                      (ngModelChange)="onSelectNewSubRouteFunction($event)" required>
                    </ng-select>
                  </div>
                </div>
              </div>

              <!-- Ubicación y Territorio -->
              <div class="bg-white rounded-lg border border-gray-200 p-4">
                <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                  <mat-icon class="text-green-600">location_on</mat-icon>
                  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Ubicación y Territorio</h3>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label for="group-select">Territorio</mat-label>
                    <mat-select [formControl]="routeMultiCtrl" placeholder="Seleccione territorio" [multiple]="true">
                      <mat-option>
                        <ngx-mat-select-search [showToggleAllCheckbox]="true"
                          [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                          (toggleAll)="toggleSelectAll($event)" [formControl]="routeMultiFilterCtrl"
                          [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                          [placeholderLabel]="'Buscar territorio...'"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let route of filteredRoutes | async" [value]="route">
                        <span>
                          <b *ngIf="getCode(route) as code">
                            {{ code }} -
                          </b>{{ route.name }}
                        </span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
                    routeMultiCtrl.hasError('required') &&
                    (routeMultiCtrl.dirty || routeMultiCtrl.touched)
                  ">
                      Seleccione un territorio
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label for="group-select">Áreas de Rutas</mat-label>
                    <mat-select [formControl]="routeAreaMultiCtrl" placeholder="Seleccione las áreas de ruta"
                      [multiple]="true">
                      <mat-option>
                        <ngx-mat-select-search [showToggleAllCheckbox]="true"
                          [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                          (toggleAll)="toggleSelectAllRouteArea($event)" [formControl]="routeAreaMultiFilterCtrl"
                          [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                          [placeholderLabel]="'Buscar áreas de ruta...'"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let routeArea of filteredRouteAreas | async" [value]="routeArea">
                        <span>
                          <b *ngIf="getCode(routeArea) as code">
                            {{ code }} -
                          </b>{{ routeArea.name }}
                        </span>
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
                    routeAreaMultiCtrl.hasError('required') &&
                    (routeAreaMultiCtrl.dirty || routeAreaMultiCtrl.touched)
                  ">
                      Seleccione las áreas de ruta
                    </mat-error>
                  </mat-form-field>

                  <div class="col-span-1 lg:col-span-2">
                    <label>Grupo de Rutas</label>
                    <ng-select [(ngModel)]="currentCreateSubRoute.routeGroupId" [items]="routeGroupList"
                      bindLabel="name" bindValue="_id" [searchable]="true" [appendTo]="'body'"
                      placeholder="Seleccionar un grupo" name="routeGroupId" required>
                    </ng-select>
                  </div>
                </div>
              </div>

              <!-- Organización y Empresa -->
              <div class="bg-white rounded-lg border border-gray-200 p-4">
                <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                  <mat-icon class="text-purple-600">business</mat-icon>
                  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Organización y Empresa</h3>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div class="col-span-1">
                    <label for="group-select">Compañía</label>
                    <ng-select [(ngModel)]="currentCreateSubRoute.companyId" [items]="companyList" bindLabel="name"
                      bindValue="_id" [searchable]="true" placeholder="Seleccione una compania" name="companyId"
                      [appendTo]="'body'" required>
                    </ng-select>
                  </div>

                  <div class="col-span-1">
                    <label>Planta</label>
                    <ng-select [(ngModel)]="currentCreateSubRoute.plantId" [items]="plants" bindLabel="name"
                      bindValue="_id" [searchable]="true" [appendTo]="'body'" placeholder="Selecciona una planta"
                      name="plantId">
                      <ng-template ng-label-tmp let-item="item">
                        <span *ngIf="item?.externalKeys"><b>{{ item?.externalKeys?.code }}</b> -
                        </span><span>{{item.name}}</span>
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="col-span-1">
                    <label>Oficina de Venta</label>
                    <ng-select [(ngModel)]="currentCreateSubRoute.salesOfficeId" [items]="salesOfficeList"
                      bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione Oficina de venta"
                      name="salesOfficeId" [appendTo]="'body'" required>
                    </ng-select>
                  </div>

                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label for="group-select">Almacenes</mat-label>
                    <mat-select [formControl]="warehouseMultiCtrl" placeholder="Seleccione los almacenes"
                      [multiple]="true">
                      <mat-option>
                        <ngx-mat-select-search [showToggleAllCheckbox]="true"
                          [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                          (toggleAll)="toggleSelectAllWarehouse($event)" [formControl]="warehouseMultiFilterCtrl"
                          [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                          [placeholderLabel]="'Buscar almacenes...'"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let warehouse of filteredWarehouses | async" [value]="warehouse">
                        <span *ngIf="warehouse?.externalKeys"><b>{{ warehouse?.externalKeys?.code }}</b> - </span>{{
                        warehouse.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
                    warehouseMultiCtrl.hasError('required') &&
                    (warehouseMultiCtrl.dirty || warehouseMultiCtrl.touched)
                  ">
                      Seleccione los almacenes
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- Personal y Responsabilidades -->
              <div class="bg-white rounded-lg border border-gray-200 p-4">
                <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                  <mat-icon class="text-orange-600">people</mat-icon>
                  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Personal y Responsabilidades
                  </h3>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div class="col-span-1">
                    <label for="group-select">Usuario</label>
                    <ng-select [(ngModel)]="currentCreateSubRoute.mainCollaborator.masterUserId"
                      [items]="mainCollabList" bindLabel="username" bindValue="masterUserId" [searchable]="true"
                      placeholder="Seleccione el usuario" notFoundText="No se encontraron usuarios disponibles"
                      name="masterUserId" [appendTo]="'body'" (change)="onMainCollabChange($event)">
                      <ng-template ng-label-tmp let-item="item">
                        <span style="font-size: 12px;">
                          {{ item.username }} -
                          <b class="uppercase">{{ item.businessPartnerName || 'SIN SOCIO ASIGNADO' }}</b></span>
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item">
                        <b style="font-size: 11px;">{{ item.username }}</b><br>
                        <div class="uppercase" style="font-size: 11px;">
                          - {{ item.businessPartnerName || 'SIN SOCIO ASIGNADO' }}</div>
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="col-span-1">
                    <label for="group-select">Responsable</label>
                    <ng-select [(ngModel)]="currentCreateSubRoute.responsibleBusinessPartnerId"
                      [items]="businessPartnerRespList" bindLabel="name" bindValue="_id" [searchable]="true"
                      placeholder="Seleccione el responsable" name="responsibleBusinessPartnerId" [appendTo]="'body'">
                      <ng-template ng-label-tmp let-item="item">
                        <span>
                          <b *ngIf="getCode(item) as code">
                            {{ code }} -
                          </b>{{ item.name }}
                        </span>
                      </ng-template>
                    </ng-select>
                  </div>

                  <mat-form-field *ngIf="subRouteFunctionSelected && subRouteFunctionSelected.vehicleRequired == true"
                    appearance="fill" class="col-span-1">
                    <mat-label>Vehículo</mat-label>
                    <mat-select [formControl]="vehicleCtrl" placeholder="Seleccione un vehículo">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="vehicleFilterCtrl"
                          [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                          [placeholderLabel]="'Buscar vehículo...'"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let vehicle of filteredVehicles | async" [value]="vehicle">
                        <div class="text-sm uppercase leading-tight">
                          <div>
                            <b class="f-10">{{ getCode(vehicle) }}</b>
                          </div>
                          {{ vehicle.name }}
                        </div>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Configuraciones Especiales">
              <!-- Configuraciones Especiales -->
              <div class="bg-white rounded-lg border border-gray-200 p-4"
                *ngIf="subRouteFunctionSelected && subRouteFunctionSelected.model == '07'">
                <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                  <mat-icon class="text-indigo-600">settings</mat-icon>
                  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Configuraciones Especiales
                  </h3>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label for="group-select">Ruta de Entrega para Cliente Eventual</mat-label>
                    <mat-select [formControl]="subrouteMultiCtrl" placeholder="Seleccione las rutas">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="subrouteMultiFilterCtrl"
                          [placeholderLabel]="'Buscar ruta de entrega...'"
                          [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let route of filteredRoute | async" [value]="route._id">
                        <span>
                          <b *ngIf="getCode(route) as code">
                            {{ code }} -
                          </b>{{ route.name }}
                        </span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label for="group-select">Ruta de Entrega para Consumidor Final</mat-label>
                    <mat-select [formControl]="subrouteCMultiCtrl" placeholder="Seleccione las rutas">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="subrouteCMultiFilterCtrl"
                          [placeholderLabel]="'Buscar ruta de entrega...'"
                          [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let route of filteredCRoute | async" [value]="route._id">
                        <span>
                          <b *ngIf="getCode(route) as code">
                            {{ code }} -
                          </b>{{ route.name }}
                        </span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Configuraciones de Comportamiento -->
              <div class="bg-white rounded-lg border border-gray-200 p-4">
                <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                  <mat-icon class="text-red-600">tune</mat-icon>
                  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Configuraciones de
                    Comportamiento</h3>
                </div>

                <div class="space-y-4">
                  <!-- Toggle GPS -->
                  <div class="bg-default rounded-lg p-4 border border-gray-200">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-3">
                      <div class="flex items-start sm:items-center gap-3">
                        <mat-icon class="text-blue-600 mt-1 sm:mt-0">gps_fixed</mat-icon>
                        <div>
                          <h4 class="font-medium text-gray-800">Validación GPS</h4>
                          <p class="text-sm text-gray-600">¿Se valida el GPS para esta ruta?</p>
                        </div>
                      </div>
                      <mat-slide-toggle [(ngModel)]="currentCreateSubRoute.useGps" name="useGps" color="primary"
                        class="flex-shrink-0">
                      </mat-slide-toggle>
                    </div>

                    <div *ngIf="currentCreateSubRoute.useGps" class="pt-3 border-t border-gray-200">
                        <div class="flex flex-col sm:flex-row gap-4 mt-3">
                        <!-- Modo de validación -->
                        <mat-form-field appearance="fill" class="w-full sm:flex-1">
                          <mat-label>Modo de validación GPS</mat-label>
                          <mat-select [(ngModel)]="currentCreateSubRoute.useGpsMode" name="useGpsMode">
                            <mat-option *ngFor="let mode of useGpsList" [value]="mode.value">
                              {{ mode.key | transloco }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <!-- Distancia -->
                        <mat-form-field appearance="fill" class="w-full sm:flex-1">
                          <mat-label>Distancia a validar entre vendedor y cliente</mat-label>
                          <input matInput [(ngModel)]="currentCreateSubRoute.distanceBtwSellerAndCustomer"
                            name="distanceBtwSellerAndCustomer" type="number" min="0" required />
                          <mat-suffix>km</mat-suffix>
                        </mat-form-field>
                      </div>          
                    </div>
                  </div>

                  <!-- Toggle Direcciones -->
                  <div class="bg-default rounded-lg p-4 border border-gray-200">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                      <div class="flex items-start sm:items-center gap-3">
                        <mat-icon class="text-green-600 mt-1 sm:mt-0">location_city</mat-icon>
                        <div>
                          <h4 class="font-medium text-gray-800">Direcciones de Entrega</h4>
                          <p class="text-sm text-gray-600">¿Enviar todas las direcciones de entrega del cliente, incluso
                            fuera del territorio actual?</p>
                        </div>
                      </div>
                      <mat-slide-toggle [(ngModel)]="currentCreateSubRoute.sendAllCustomersDeliveryAddresses"
                        name="sendAllCustomersDeliveryAddresses" color="primary" class="flex-shrink-0">
                      </mat-slide-toggle>
                    </div>
                  </div>

                  <!-- Toggle Clientes sin Frecuencia -->
                  <div class="bg-default rounded-lg p-4 border border-gray-200">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                      <div class="flex items-start sm:items-center gap-3">
                        <mat-icon class="text-purple-600 mt-1 sm:mt-0">group_add</mat-icon>
                        <div>
                          <h4 class="font-medium text-gray-800">Clientes con Frecuencia</h4>
                          <p class="text-sm text-gray-600">Mostrar en APP solo clientes con frecuencia</p>
                        </div>
                      </div>
                      <mat-slide-toggle [(ngModel)]="currentCreateSubRoute.sendAllCustomersWithNoFreqButTerritory"
                        name="sendAllCustomersWithNoFreqButTerritory" color="primary" class="flex-shrink-0">
                      </mat-slide-toggle>
                    </div>
                  </div>

                  <div class="bg-default rounded-lg p-4 border border-gray-200">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div class="flex items-center gap-3">
                        <mat-icon class="text-purple-600">location_on</mat-icon>
                        <div>
                          <h4 class="font-medium text-gray-800">Geolocalización sin solicitud de repineo</h4>
                          <p class="text-sm text-gray-600">¿Permitir tomar la geolocalización sin una solicitud de repineo?</p>
                        </div>
                      </div>
                      <mat-slide-toggle [(ngModel)]="currentCreateSubRoute.allowLocationWithoutRepin"
                        name="allowLocationWithoutRepin" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-2 items-start gap-4 py-1">
                    <app-toggle-option [(ngModel)]="currentCreateSubRoute.allowManualBonus" name="allowManualBonus" icon="workspace_premium"
                      iconColor="purple" title="¿Permite bonificaciones manuales?" description="Indica si el sistema permite registrar o aplicar bonificaciones de forma manual, sin depender de reglas o procesos automáticos.">
                    </app-toggle-option>

                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Modo de determinación de condiciones comerciales</mat-label>
                      <mat-select [(ngModel)]="currentCreateSubRoute.commercialConditionMode" name="commercialConditionMode">
                        @for (commercialConditionMode of commercialConditionModeList; track commercialConditionMode) {
                        <mat-option [value]="commercialConditionMode">
                          {{ getCommercialConditionModeLabel(commercialConditionMode) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- <div class="py-1">
                    <app-toggle-option [(ngModel)]="currentCreateSubRoute.allowDeliveryDateChange" name="allowDeliveryDateChange" icon="calendar_today"
                      iconColor="green" title="¿Permitir cambio de fecha de entrega?" description="Permite definir si el usuario puede modificar la fecha de entrega al crear un pedido de venta ">
                    </app-toggle-option>
                  </div> -->

                  <!-- Campo de forzar cierre -->
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Estrategia de asignación en rutas de entrega</mat-label>
                      <mat-select [(ngModel)]="currentCreateSubRoute.deliveryAssignmentStrategy" name="deliveryAssignmentStrategy">
                        @for (deliveryAssignmentStrategy of deliveryAssignmentStrategyList; track deliveryAssignmentStrategy) {
                        <mat-option [value]="deliveryAssignmentStrategy">
                          {{ getDeliveryAssignmentStrategyLabel(deliveryAssignmentStrategy) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>¿Se obliga a cerrar un viaje con fecha fin pasada?</mat-label>
                      <mat-select [(ngModel)]="currentCreateSubRoute.forceCloseTripPastEndDate" name="forceCloseTripPastEndDate">
                        @for (forceCloseTripM of forceCloseTripList; track forceCloseTripM) {
                        <mat-option [value]="forceCloseTripM">
                          {{ getForceCloseTripLabel(forceCloseTripM) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Tratamiento de bonificaciones manuales</mat-label>
                      <mat-select [(ngModel)]="currentCreateSubRoute.manualBonusHandling" name="manualBonusHandling">
                        @for (bonus of bonusHandlingOptions; track bonus) {
                        <mat-option [value]="bonus.value">
                          {{ bonus.label }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>¿Consultar si se hará cobranza durante la entrega?</mat-label>
                      <mat-select [(ngModel)]="currentCreateSubRoute.invoicedDeliveryCollectionBehaviour"
                        name="invoicedDeliveryCollectionBehaviour">
                        @for (value of invoicedDeliveryCollectionBehaviourList; track value) {
                        <mat-option [value]="value">
                          {{ getInvoicedDeliveryCollectionBehaviourLabel(value) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>



        </form>
      </mat-dialog-content>
      <mat-dialog-actions
        class="modal-actions flex flex-col sm:flex-row justify-between gap-3 px-6 py-4 border-t border-gray-200">
        <button mat-button mat-dialog-close class="order-2 sm:order-1">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createSubRoute()"
          [disabled]="!createForm.valid || routeMultiCtrl.invalid || routeAreaMultiCtrl.invalid || noPartnerAssigned "
          class="order-1 sm:order-2 w-full sm:w-auto">
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar ruta {{this.currentUpdateSubRoute.name}}</h2>
      <mat-dialog-content id="editModalContent" class="!p-0 !max-h-none">
        <form #editForm="ngForm" class="space-y-6">
          <mat-tab-group>
            <mat-tab class="flex flex-col gap-y-4" label="Información general">
              <div class="flex flex-col gap-y-4 w-full">
                <!-- Información Básica -->
                <div class="bg-white rounded-lg border border-gray-200 p-4">
                  <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                    <mat-icon class="text-blue-600">info</mat-icon>
                    <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Información Básica</h3>
                  </div>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Código Externo</mat-label>
                      <input matInput [(ngModel)]="currentUpdateSubRoute.externalKeys.code" name="code" disabled />
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Nombre</mat-label>
                      <input matInput [(ngModel)]="currentUpdateSubRoute.name" name="name" required />
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Tipo</mat-label>
                      <mat-select [(ngModel)]="currentUpdateSubRoute.type" name="type" required>
                        <mat-option *ngFor="let type of typeList" [value]="type.value">
                          {{ type.key | transloco }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="col-span-1">
                      <label>Función</label>
                      <ng-select [(ngModel)]="currentUpdateSubRoute.function" [items]="functionList" bindLabel="name"
                        bindValue="_id" [searchable]="true" placeholder="Seleccione una función de ruta"
                        name="subRouteFunctionId" [appendTo]="'body'"
                        (ngModelChange)="onFunctionSelectionChange($event); onSelectNewSubRouteFunction($event)"
                        [compareWith]="compareById" required>
                      </ng-select>
                    </div>
                  </div>
                </div>

                <!-- Ubicación y Territorio -->
                <div class="bg-white rounded-lg border border-gray-200 p-4">
                  <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                    <mat-icon class="text-green-600">location_on</mat-icon>
                    <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Ubicación y Territorio</h3>
                  </div>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label for="group-select">Territorio</mat-label>
                      <mat-select [formControl]="routeMultiCtrl" placeholder="Seleccione territorio" [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                            (toggleAll)="toggleSelectAll($event)" [formControl]="routeMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'"
                            [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar territorio...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let route of filteredRoutes | async" [value]="route">
                          <b *ngIf="getCode(route) as code">
                            {{ code }} -
                          </b>{{ route.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="
                          routeMultiCtrl.hasError('required') &&
                          (routeMultiCtrl.dirty || routeMultiCtrl.touched)
                        ">
                        Seleccione un territorio
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label for="group-select">Áreas de Rutas</mat-label>
                      <mat-select [formControl]="routeAreaMultiCtrl" placeholder="Seleccione las áreas de ruta"
                        [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                            (toggleAll)="toggleSelectAllRouteArea($event)" [formControl]="routeAreaMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'"
                            [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar áreas de ruta...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let routeArea of filteredRouteAreas | async" [value]="routeArea">
                          <b *ngIf="getCode(routeArea) as code">
                            {{ code }} -
                          </b>{{ routeArea.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="
                            routeAreaMultiCtrl.hasError('required') &&
                            (routeAreaMultiCtrl.dirty || routeAreaMultiCtrl.touched)
                          ">
                        Seleccione las áreas de ruta
                      </mat-error>
                    </mat-form-field>

                    <div class="col-span-1 md:col-span-2 lg:col-span-1">
                      <label>Grupo de Rutas</label>
                      <ng-select [(ngModel)]="currentUpdateSubRoute.routeGroup" [items]="routeGroupList"
                        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccionar un grupo"
                        name="routeGroupId" [appendTo]="'body'" [compareWith]="compareById"
                        (ngModelChange)="onRouteGroupSelectionChange($event)" required>
                      </ng-select>
                    </div>
                  </div>
                </div>

                <!-- Organización y Empresa -->
                <div class="bg-white rounded-lg border border-gray-200 p-4">
                  <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                    <mat-icon class="text-purple-600">business</mat-icon>
                    <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Organización y Empresa</h3>
                  </div>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div class="col-span-1">
                      <label for="group-select">Compañía</label>
                      <ng-select [(ngModel)]="currentUpdateSubRoute.company" [items]="companyList" bindLabel="name"
                        bindValue="_id" [searchable]="true" placeholder="Seleccione una compania" name="companyId"
                        [compareWith]="compareById" [appendTo]="'body'"
                        (ngModelChange)="onCompanySelectionChange($event)" required>
                      </ng-select>
                    </div>

                    <div class="col-span-1">
                      <label>Planta</label>
                      <ng-select [(ngModel)]="currentUpdateSubRoute.plant" [items]="plants" bindLabel="name"
                        bindValue="_id" [searchable]="true" [appendTo]="'body'" placeholder="Selecciona una planta"
                        name="plantId" [compareWith]="compareById" (ngModelChange)="onPlantSelectionChange($event)">
                        <ng-template ng-label-tmp let-item="item">
                          <span *ngIf="item?.externalKeys"><b>{{ item?.externalKeys?.code }}</b> -
                          </span><span>{{item.name}}</span>
                        </ng-template>
                      </ng-select>
                    </div>

                    <div class="col-span-1">
                      <label>Oficina de Venta</label>
                      <ng-select [(ngModel)]="currentUpdateSubRoute.salesOffice" [items]="salesOfficeList"
                        bindLabel="name" bindValue="_id" [searchable]="true" placeholder="Seleccione Oficina de venta"
                        name="salesOfficeId" (ngModelChange)="onSalesOfficeSelectionChange($event)"
                        [compareWith]="compareById" [appendTo]="'body'" required>
                      </ng-select>
                    </div>

                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label for="group-select">Almacenes</mat-label>
                      <mat-select [formControl]="warehouseMultiCtrl" placeholder="Seleccione los almacenes"
                        [multiple]="true">
                        <mat-option>
                          <ngx-mat-select-search [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                            (toggleAll)="toggleSelectAllWarehouse($event)" [formControl]="warehouseMultiFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'"
                            [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar almacenes...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let warehouse of filteredWarehouses | async" [value]="warehouse">
                          <span *ngIf="warehouse?.externalKeys"><b>{{ warehouse?.externalKeys?.code }}</b> - </span>{{
                          warehouse.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="
                            warehouseMultiCtrl.hasError('required') &&
                            (warehouseMultiCtrl.dirty || warehouseMultiCtrl.touched)
                          ">
                        Seleccione los almacenes
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Personal y Responsabilidades -->
                <div class="bg-white rounded-lg border border-gray-200 p-4">
                  <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                    <mat-icon class="text-orange-600">people</mat-icon>
                    <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Personal y Responsabilidades
                    </h3>
                  </div>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div class="col-span-1">
                      <label for="group-select">Usuario</label>
                      <ng-select [(ngModel)]="currentUpdateSubRoute.mainCollaborator.masterUserId"
                        [items]="mainCollabList" bindLabel="username" bindValue="masterUserId"
                        notFoundText="No se encontraron usuarios disponibles" [searchable]="true"
                        placeholder="Seleccione el usuario" name="masterUserId" [compareWith]="compareByMaster"
                        [appendTo]="'body'" (change)="onMainCollabChange($event)">
                        <ng-template ng-label-tmp let-item="item">
                          <span style="font-size: 12px;">
                            {{ item.username }} -
                            <b class="uppercase">{{ item.businessPartnerName || 'SIN SOCIO ASIGNADO' }}</b></span>
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item">
                          <b style="font-size: 11px;">{{ item.username }}</b><br>
                          <div class="uppercase" style="font-size: 11px;">
                            - {{ item.businessPartnerName || 'SIN SOCIO ASIGNADO' }}</div>
                        </ng-template>
                      </ng-select>
                    </div>

                    <div class="col-span-1">
                      <label for="group-select">Responsable</label>
                      <ng-select [(ngModel)]="currentUpdateSubRoute.responsibleBusinessPartnerId"
                        [items]="businessPartnerRespList" bindLabel="name" bindValue="_id" [searchable]="true"
                        placeholder="Seleccione el responsable" name="responsibleBusinessPartnerId"
                        [compareWith]="compareByRes" [appendTo]="'body'">
                        <ng-template ng-label-tmp let-item="item">
                          <span>
                            <b *ngIf="getCode(item) as code">
                              {{ code }} -
                            </b>{{ item.name }}
                          </span>
                        </ng-template>
                      </ng-select>
                    </div>

                    <mat-form-field *ngIf="subRouteFunctionSelected && subRouteFunctionSelected.vehicleRequired == true"
                      appearance="fill" class="col-span-1 md:col-span-2 lg:col-span-1">
                      <mat-label>Vehículo</mat-label>
                      <mat-select [formControl]="vehicleCtrl" placeholder="Seleccione un vehículo">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="vehicleFilterCtrl"
                            [noEntriesFoundLabel]="'No se encontraron resultados'" [clearSearchLabel]="'Limpiar búsqueda'"
                            [placeholderLabel]="'Buscar vehículo...'"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let vehicle of filteredVehicles | async" [value]="vehicle">
                          <div class="text-sm uppercase leading-tight">
                            <div>
                              <b class="f-10">{{ getCode(vehicle) }}</b>
                            </div>
                            {{ vehicle.name }}
                          </div>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-tab>

            <mat-tab label="Configuraciones">
              <!-- Configuraciones Especiales -->
              <div class="bg-white rounded-lg border border-gray-200 p-4"
                *ngIf="subRouteFunctionSelected && subRouteFunctionSelected.model == '07'">
                <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                  <mat-icon class="text-indigo-600">settings</mat-icon>
                  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Configuraciones Especiales
                  </h3>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label for="group-select">Ruta de Entrega para Cliente Eventual</mat-label>
                    <mat-select [formControl]="subrouteMultiCtrl" placeholder="Seleccione las rutas">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="subrouteMultiFilterCtrl"
                          [placeholderLabel]="'Buscar ruta de entrega...'"
                          [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let route of filteredRoute | async" [value]="route._id">
                        <span>
                          <b *ngIf="getCode(route) as code">
                            {{ code }} -
                          </b>{{ route.name }}
                        </span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="fill" class="col-span-1">
                    <mat-label for="group-select">Ruta de Entrega para Consumidor Final</mat-label>
                    <mat-select [formControl]="subrouteCMultiCtrl" placeholder="Seleccione las rutas">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="subrouteCMultiFilterCtrl"
                          [placeholderLabel]="'Buscar ruta de entrega...'"
                          [noEntriesFoundLabel]="'No se encontraron resultados'"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let route of filteredCRoute | async" [value]="route._id">
                        <span>
                          <b *ngIf="getCode(route) as code">
                            {{ code }} -
                          </b>{{ route.name }}
                        </span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Configuraciones de Comportamiento -->
              <div class="bg-white rounded-lg border border-gray-200 p-4 mt-4">
                <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100">
                  <mat-icon class="text-red-600">tune</mat-icon>
                  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">Configuraciones de
                    Comportamiento</h3>
                </div>

                <div class="space-y-4">
                  <!-- Toggle GPS -->
                  <div class="bg-default rounded-lg p-4 border border-gray-200">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-3 gap-4">
                      <div class="flex items-center gap-3">
                        <mat-icon class="text-blue-600">gps_fixed</mat-icon>
                        <div>
                          <h4 class="font-medium text-gray-800">Validación GPS</h4>
                          <p class="text-sm text-gray-600">¿Se valida el GPS para esta ruta?</p>
                        </div>
                      </div>
                      <mat-slide-toggle [(ngModel)]="currentUpdateSubRoute.useGps" name="useGps" color="primary">
                      </mat-slide-toggle>
                    </div>

                    <div *ngIf="currentUpdateSubRoute.useGps" class="pt-3 border-t border-gray-200">
                      <div class="flex flex-col sm:flex-row gap-4 mt-3">
                        <!-- Modo de validación -->
                        <mat-form-field appearance="fill" class="w-full sm:flex-1">
                          <mat-label>Modo de validación GPS</mat-label>
                          <mat-select [(ngModel)]="currentUpdateSubRoute.useGpsMode" name="useGpsMode">
                            <mat-option *ngFor="let mode of useGpsList" [value]="mode.value">
                              {{ mode.key | transloco }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <!-- Distancia -->
                        <mat-form-field appearance="fill" class="w-full sm:flex-1">
                          <mat-label>Distancia a validar entre vendedor y cliente</mat-label>
                          <input matInput [(ngModel)]="currentUpdateSubRoute.distanceBtwSellerAndCustomer"
                            name="distanceBtwSellerAndCustomer" type="number" min="0" required />
                          <mat-suffix>km</mat-suffix>
                        </mat-form-field>
                    
                      </div>                    
                    </div>

                  </div>

                  <!-- Toggle Direcciones -->
                  <div class="bg-default rounded-lg p-4 border border-gray-200">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div class="flex items-center gap-3">
                        <mat-icon class="text-green-600">location_city</mat-icon>
                        <div>
                          <h4 class="font-medium text-gray-800">Direcciones de Entrega</h4>
                          <p class="text-sm text-gray-600">¿Enviar todas las direcciones de entrega del cliente, incluso
                            fuera del territorio actual?</p>
                        </div>
                      </div>
                      <mat-slide-toggle [(ngModel)]="currentUpdateSubRoute.sendAllCustomersDeliveryAddresses"
                        name="sendAllCustomersDeliveryAddresses" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </div>

                  <!-- Toggle Clientes sin Frecuencia -->
                  <div class="bg-default rounded-lg p-4 border border-gray-200">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div class="flex items-center gap-3">
                        <mat-icon class="text-purple-600">group_add</mat-icon>
                        <div>
                          <h4 class="font-medium text-gray-800">Clientes con Frecuencia</h4>
                          <p class="text-sm text-gray-600">Mostrar en APP solo clientes con frecuencia</p>
                        </div>
                      </div>
                      <mat-slide-toggle [(ngModel)]="currentUpdateSubRoute.sendAllCustomersWithNoFreqButTerritory"
                        name="sendAllCustomersWithNoFreqButTerritory" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </div>

                  <!-- Toggle permite geolocalización sin solicitu de repineo -->
                  <div class="bg-default rounded-lg p-4 border border-gray-200">
                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div class="flex items-center gap-3">
                        <mat-icon class="text-purple-600">location_on</mat-icon>
                        <div>
                          <h4 class="font-medium text-gray-800">Geolocalización sin solicitud de repineo</h4>
                          <p class="text-sm text-gray-600">¿Permitir tomar la geolocalización sin una solicitud de repineo?</p>
                        </div>
                      </div>
                      <mat-slide-toggle [(ngModel)]="currentUpdateSubRoute.allowLocationWithoutRepin"
                        name="allowLocationWithoutRepin" color="primary">
                      </mat-slide-toggle>
                    </div>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-2 items-start gap-4 py-1">
                    <app-toggle-option [(ngModel)]="currentUpdateSubRoute.allowManualBonus" name="allowManualBonus" icon="workspace_premium"
                      iconColor="purple" title="¿Permite bonificaciones manuales?" description="Indica si el sistema permite registrar o aplicar bonificaciones de forma manual, sin depender de reglas o procesos automáticos.">
                    </app-toggle-option>

                    <mat-form-field appearance="fill" class="w-full">
                      <mat-label>Modo de determinación de condiciones comerciales</mat-label>
                      <mat-select [(ngModel)]="currentUpdateSubRoute.commercialConditionMode" name="commercialConditionMode">
                        @for (commercialConditionMode of commercialConditionModeList; track commercialConditionMode) {
                        <mat-option [value]="commercialConditionMode">
                          {{ getCommercialConditionModeLabel(commercialConditionMode) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- <div class="py-1">
                    <app-toggle-option [(ngModel)]="currentUpdateSubRoute.allowDeliveryDateChange" name="allowDeliveryDateChange" icon="calendar_today"
                      iconColor="green" title="¿Permitir cambio de fecha de entrega?" description="Permite definir si el usuario puede modificar la fecha de entrega al crear un pedido de venta ">
                    </app-toggle-option>
                  </div> -->

                  <!-- Campo de forzar cierre -->
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Estrategia de asignación en rutas de entrega</mat-label>
                      <mat-select [(ngModel)]="currentUpdateSubRoute.deliveryAssignmentStrategy" name="deliveryAssignmentStrategy">
                        @for (deliveryAssignmentStrategy of deliveryAssignmentStrategyList; track deliveryAssignmentStrategy) {
                        <mat-option [value]="deliveryAssignmentStrategy">
                          {{ getDeliveryAssignmentStrategyLabel(deliveryAssignmentStrategy) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>¿Se obliga a cerrar un viaje con fecha fin pasada?</mat-label>
                      <mat-select [(ngModel)]="currentUpdateSubRoute.forceCloseTripPastEndDate" name="forceCloseTripPastEndDate">
                        @for (forceCloseTripM of forceCloseTripList; track forceCloseTripM) {
                        <mat-option [value]="forceCloseTripM">
                          {{ getForceCloseTripLabel(forceCloseTripM) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>Tratamiento de bonificaciones manuales</mat-label>
                      <mat-select [(ngModel)]="currentUpdateSubRoute.manualBonusHandling" name="manualBonusHandling">
                        @for (bonus of bonusHandlingOptions; track bonus) {
                        <mat-option [value]="bonus.value">
                          {{ bonus.label }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  
                    <mat-form-field appearance="fill" class="col-span-1">
                      <mat-label>¿Consultar si se hará cobranza durante la entrega?</mat-label>
                      <mat-select [(ngModel)]="currentUpdateSubRoute.invoicedDeliveryCollectionBehaviour"
                        name="invoicedDeliveryCollectionBehaviour">
                        @for (value of invoicedDeliveryCollectionBehaviourList; track value) {
                        <mat-option [value]="value">
                          {{ getInvoicedDeliveryCollectionBehaviourLabel(value) }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-between px-6 py-4 border-t border-gray-200">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <div class="flex flex-col sm:flex-row gap-2">
          <button *ngIf="(PERMISSIONS_TRIPS.VIEW | hasPermission) && canShowCreateTripsFromItinerary()" type="button" mat-stroked-button color="accent"
            (click)="manualCreateTripsForSubRoute()" [disabled]="isCreatingTripsFromItinerary">
            <mat-icon class="mr-1">auto_awesome</mat-icon>
            Crear viajes a partir de itinerario
          </button>
          <button mat-raised-button color="primary" (click)="updateSubRoute(currentUpdateSubRoute._id)"
            [disabled]="!editForm.valid || routeMultiCtrl.invalid || routeAreaMultiCtrl.invalid || noPartnerAssigned">
            Guardar
          </button>
        </div>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #viewRoutesModal>
      <app-routes-detail-by-business-partner-vehicle
        [typeModal]="'vehicle'" [search]="true"></app-routes-detail-by-business-partner-vehicle>
    </ng-template>
  </div>

  <!-- Modal Frecuencia  -->

  <ng-template #addModalFrequency>
    <div class="flex justify-between items-center mb-2">
      <h2 mat-dialog-title class="text-lg font-bold">
        Asignar Frecuencia para {{ this.currentUpdateSubRoute.name }}
      </h2>
      <!-- <h2 class="text-lg font-bold mb-1">Clientes Sin Asignar</h2> -->
      <div>
        <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.CREATE" mat-button (click)="openAddFrequencyModal()" matTooltip="Asignar Frecuencia">
          <mat-icon svgIcon="heroicons_outline:plus-circle"></mat-icon>
        </button>
        <button mat-button (click)="toggleSecondDiv()" matTooltip="Asignar clientes">
          <mat-icon svgIcon="heroicons_outline:user-plus"></mat-icon>
        </button>
        <button mat-button mat-dialog-close matTooltip="Cerrar">
          <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
        </button>
      </div>
    </div>
    <mat-dialog-content class="modal-content-frequency">
      <div class="flex-frequency">
        <div #flex1 class="flex-frecuency">
          <!-- <div class="flex justify-end mb-2">
            <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.CREATE"
              mat-button
              (click)="openAddFrequencyModal()"
              matTooltip="Asignar Frecuencia"
            >
              <mat-icon svgIcon="heroicons_outline:plus-circle"></mat-icon>
              <span></span>
            </button>
          </div> -->
          <div class="flex justify-end mb-2">
            <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64">
              <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
              <input matInput placeholder="Buscar" [(ngModel)]="filterValue" autocomplete="off"
                (input)="onSearchChangeFrequency($event)" />
            </mat-form-field>
          </div>
          <div *ngFor="
              let frequencyType of groupedFrequencies | keyvalue;
              let isFirst = first
            ">
            <mat-expansion-panel (opened)="isFirst && toggleFirstPanel(true)"
              (closed)="isFirst && toggleFirstPanel(false)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ frequencyNames[frequencyType.key] }} ({{
                  frequencyType.value?.frequencies?.length || 0
                  }})
                </mat-panel-title>
                <mat-panel-description> </mat-panel-description>
              </mat-expansion-panel-header>
              <mat-expansion-panel-content>
                <table mat-table [dataSource]="frequencyType.value.frequencies" multiTemplateDataRows
                  class="min-w-500 overflow-y-visible mat-elevation-z">
                  <ng-container *ngFor="let column of displayedColumnsF" matColumnDef="{{ column }}">
                    <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
                    <td mat-cell *matCellDef="let element">
                      <ng-container *ngIf="column === 'Acciones'; else defaultContent">
                        <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones"
                          [ngClass]="{ hidden: !isSmallScreen }" (click)="$event.stopPropagation()">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionMenu="matMenu">
                          <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.UPDATE" mat-icon-button (click)="
                              openAddFrequencyModal(element);
                              $event.stopPropagation()
                            ">
                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                          </button>
                          <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.DELETE" mat-icon-button (click)="
                              openDeleteFrequency(element);
                              $event.stopPropagation()
                            ">
                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                          </button>
                        </mat-menu>
                      </ng-container>
                      <ng-container *ngIf="column === 'Acciones'; else defaultContent">
                        <div [ngClass]="{ hidden: isSmallScreen }">
                          <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.UPDATE" mat-icon-button (click)="
                              openAddFrequencyModal(element);
                              $event.stopPropagation()
                            ">
                            <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                          </button>
                          <button *canPermissionsOnly="PERMISSIONS_FREQUENCIES.DELETE" mat-icon-button (click)="
                              openDeleteFrequency(element);
                              $event.stopPropagation()
                            ">
                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                          </button>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="column === 'Dias'; else defaultContent">
                        {{ getDayNames(element.days) || "N/A" }}
                      </ng-container>
                      <ng-container *ngIf="column === 'Clientes'; else defaultContent">
                        <p>Clientes: {{ element.businessPartners.length }}</p>
                      </ng-container>
                      <ng-container *ngIf="column === 'Estado'; else defaultContent">
                        <mat-slide-toggle [checked]="element.statusId === 1"
                          (change)="onStatusFrequency($event.checked, element)" color="primary">
                        </mat-slide-toggle>
                      </ng-container>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef aria-label="row actions">
                      &nbsp;
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <button mat-icon-button aria-label="expand row" (click)="
                          toggleExpand(element); $event.stopPropagation()
                        ">
                        @if (expandedElement === element) {
                        <mat-icon svgIcon="heroicons_outline:chevron-down"></mat-icon>
                        } @else {
                        <mat-icon svgIcon="heroicons_outline:chevron-right"></mat-icon>
                        }
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsFWithExpand.length"
                      class="indent">
                      <div class="example-element-detail" [@detailExpand]="
                          element == expandedElement ? 'expanded' : 'collapsed'
                        ">
                        <table mat-table #mainTable [id]="'table-' + element._id"
                          [(dataSource)]="businessPartenerFrequencyList" class="mat-elevation-z" cdkDropList
                          #main="cdkDropList" [cdkDropListConnectedTo]="['client']"
                          (cdkDropListDropped)="drop($event, element._id)"
                          [cdkDropListData]="businessPartenerFrequencyList">
                          <ng-container matColumnDef="Nombre">
                            <th mat-header-cell *matHeaderCellDef>Nombre</th>
                            <td mat-cell *matCellDef="let partner">
                              {{ partner.name || "Sin nombre" }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="Telefono">
                            <th mat-header-cell *matHeaderCellDef>Teléfono</th>
                            <td mat-cell *matCellDef="let partner">
                              {{
                              partner.principalPhone?.phone || "Sin teléfono"
                              }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="Contacto">
                            <th mat-header-cell *matHeaderCellDef>Contacto</th>
                            <td mat-cell *matCellDef="let partner">
                              {{
                              partner.principalContact?.fullName ||
                              "Sin contacto"
                              }}
                            </td>
                          </ng-container>
                          <!-- <ng-container matColumnDef="actions">
                   <th mat-header-cell *matHeaderCellDef></th>
                   <td mat-cell *matCellDef="let element">
                     <div class="button-container">

                     </div>
                   </td>
                 </ng-container>
     -->
                          <tr mat-header-row *matHeaderRowDef="[
                              'Nombre',
                              'Telefono',
                              'Contacto',
                            ]"></tr>
                          <tr mat-row *matRowDef="
                              let partner;
                              columns: ['Nombre', 'Telefono', 'Contacto']
                            " cdkDrag [cdkDragData]="partner"></tr>
                        </table>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsFWithExpand"></tr>
                  <tr mat-row *matRowDef="
                      let element;
                      columns: displayedColumnsFWithExpand
                    " class="example-element-row" [class.example-expanded-row]="expandedElement === element" (click)="
                      expandedElement =
                        expandedElement === element ? null : element
                    "></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
              </mat-expansion-panel-content>
            </mat-expansion-panel>
          </div>
        </div>

        <div class="resize-handle" *ngIf="isSecondDivVisible" (mousedown)="initResize($event)">
          <mat-icon [svgIcon]="resizeIcon" aria-label="Redimensionar"></mat-icon>
        </div>

        <div class="flex-2" *ngIf="isSecondDivVisible" [style.width.px]="additionalContentWidth">
          <div style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            ">
            <h2 class="text-lg font-bold" style="margin-left: 10px; padding-bottom: 20px">
              Asignar Clientes
            </h2>
            <div style="display: flex; align-items: center">
              <div class="fuse-mat-dense fuse-mat-rounded" style="padding-bottom: 20px; margin-right: 5px">
                <mat-button-toggle-group [(ngModel)]="filterAssigned" (change)="onFilterChange($event)">
                  <mat-button-toggle value="1">A</mat-button-toggle>
                  <mat-button-toggle value="0">N/A</mat-button-toggle>
                  <mat-button-toggle value="null">Todos</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
              <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64">
                <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                <input matInput placeholder="Buscar" autocomplete="off" (input)="onSearchChangeBP($event)" />
              </mat-form-field>
            </div>
          </div>
          <div [style.padding-top.px]="isFirstPanelExpanded ? 70 : 0"></div>
          <div class="min-w-500 mat-elevation-z" style="max-height: 600px; overflow-y: auto">
            <mat-table #table id="client" [dataSource]="clientsData" class="mat-elevation-z" cdkDropList
              #client="cdkDropList" [cdkDropListConnectedTo]="getConnectedDropLists()"
              (cdkDropListDropped)="drop($event, 'client')" [cdkDropListData]="clientsData">
              <!-- <mat-table #table [dataSource]="clientsData"
                class="mat-elevation-z8"
                cdkDropList
                (cdkDropListDropped)=" drop($event)"
                [cdkDropListData]="clientsData"> -->

              <ng-container matColumnDef="Estado">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon *ngIf="
                      element.frequenciesFromThisSubRoute &&
                        element.frequenciesFromThisSubRoute.length > 0;
                      else greyIcon
                    " class="check-icon active">
                    done_all
                  </mat-icon>
                  <ng-template #greyIcon>
                    <mat-icon class="check-icon grey-icon"> done_all </mat-icon>
                  </ng-template>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Nombre">
                <mat-header-cell *matHeaderCellDef> Nombre </mat-header-cell>
                <mat-cell *matCellDef="let element">{{
                  element.name
                  }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="Telefono">
                <mat-header-cell *matHeaderCellDef> Telefono </mat-header-cell>
                <mat-cell *matCellDef="let element">{{
                  element.phones[0]?.phone
                  }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="Contacto">
                <mat-header-cell *matHeaderCellDef> Contacto</mat-header-cell>
                <mat-cell *matCellDef="let element">{{
                  element.contacts[0]?.fullName
                  }}</mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="['Estado', 'Nombre', 'Telefono', 'Contacto']"></mat-header-row>
              <mat-row *matRowDef="
                  let element;
                  columns: ['Estado', 'Nombre', 'Telefono', 'Contacto']
                " cdkDrag [cdkDragData]="element"></mat-row>
            </mat-table>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <!-- <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        </mat-dialog-actions> -->
  </ng-template>

  <!-- Modal Colaboradores  -->
  <ng-template #addModalCollaborator>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Colaborador(es)</h2>
    <mat-dialog-content class="modal-content">
      <!-- Tabla de Colaboradores -->
      <div>
        <table mat-table [dataSource]="currentUpdateSubRoute.collaborators"
          class="min-w-500 overflow-y-visible mat-elevation-z">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Cliente</th>
            <td mat-cell *matCellDef="let element">
              {{ element.businessPartner.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="function">
            <th mat-header-cell *matHeaderCellDef>Función</th>
            <td mat-cell *matCellDef="let element">
              {{ element.businessPartnerFunction.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element">
              {{ element.statusId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div class="button-container">
                <button *canPermissionsOnly="PERMISSIONS_INTERLOCUTORS.DELETE" mat-icon-button (click)="openDeleteCollaborator(element)">
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
                <button *canPermissionsOnly="PERMISSIONS_INTERLOCUTORS.UPDATE" mat-icon-button (click)="openAddCollabModal(element)">
                  <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsC"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsC"></tr>
        </table>
        <!-- Paginación -->
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    </mat-dialog-actions>
  </ng-template>

  <!-- Modal Itinerario  -->
  <!-- DEPRECATED  -->
  <ng-template #addModalItinerary>
    <mat-dialog-content> <!-- class="modal-content"-->
      <div class="text-2xl text-gray-700 text-center" style="font-weight: bold;">
        <span *ngIf="getCode(this.currentUpdateSubRoute) as code">
          <b>{{ code }} - </b>
        </span>
        {{ this.currentUpdateSubRoute.name }}
      </div>
      <mat-tab-group>
        <mat-tab label="Itinerario">
          <div>
            <mat-accordion>
              <mat-expansion-panel [(expanded)]="isAddingItinerary">
                <mat-expansion-panel-header>
                  <mat-panel-title>Agregar Itinerario</mat-panel-title>
                </mat-expansion-panel-header>

                <app-add-subroute-itinerary-modal [currentCreateSubRouteItinerary]="currentCreateSubRouteItinerary"
                  [daysList]="daysList" [actions]="actionsItinerary" [data]="data"
                  (saveItinerary)="save()"></app-add-subroute-itinerary-modal>

              </mat-expansion-panel>
            </mat-accordion>
            <table mat-table [dataSource]="currentUpdateSubRoute.itinerary"
              class="min-w-500 overflow-y-visible mat-elevation-z">
              <ng-container matColumnDef="days">
                <th mat-header-cell *matHeaderCellDef>Días</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <mat-select [(ngModel)]="element.days[0]" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                      <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  } @else{
                  {{ getDayNames(element.days) }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Acción</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <mat-select [(ngModel)]="element.action" multiple aria-label="Accion"
                      [ngModelOptions]="{standalone: true}">
                      <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                        {{action | transloco }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  } @else {
                  {{ element.action | transloco }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="datetimeStart">
                <th mat-header-cell *matHeaderCellDef>Desde</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerStartE" [(ngModel)]="element.datetimeStart"
                      [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerStartE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStartE></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  {{element?.datetimeStart | FormatDateHour: false }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="datetimeEnd">
                <th mat-header-cell *matHeaderCellDef>Hasta</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerEndE" [(ngModel)]="element.datetimeEnd"
                      [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerEndE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEndE></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  {{element?.datetimeEnd | FormatDateHour: false }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                  @if (element.isEditMode) {
                  <mat-slide-toggle [checked]="element.statusId === 1"
                    [disabled]="!(PERMISSIONS_ITINERARY.UPDATE | hasPermission)"
                    (change)="onStatusChangeItinerary($event.checked, element)" color="primary">
                  </mat-slide-toggle>
                  }@else{
                  <mat-slide-toggle [checked]="element.statusId === 1"
                    [disabled]="!(PERMISSIONS_ITINERARY.UPDATE | hasPermission)"
                    (change)="onitineraryStatusChange($event.checked, element)" color="primary">
                  </mat-slide-toggle>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  @if(isAddingItinerary){
                  <button *canPermissionsOnly="PERMISSIONS_ITINERARY.CREATE" color="primary" mat-button (click)="addItinerary(1)" matTooltip="Asignar Itinerario">
                    <!--//openAddItineraryModal(existingData, 1)"-->
                    <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    <span></span>
                  </button>
                  }
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-icon-button (click)="onUpdateItinerary(element, i)" *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (!element.isEditMode)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    </button>
                    <button mat-icon-button (click)="onSaveItinerary(element, 1)"
                      *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (element.isEditMode)"><!--openAddItineraryModal(element, 1)-->
                      <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                    </button>
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY.DELETE" mat-icon-button (click)="openDeleteItinerary(element)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsI"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsI"></tr>
            </table>
            <!-- Paginación -->
          </div>
        </mat-tab>
        <mat-tab label="Itinerario Alternativo">
          <div>
            <mat-accordion>
              <mat-expansion-panel [(expanded)]="isAddingItineraryAlternative">
                <mat-expansion-panel-header>
                  <mat-panel-title>Agregar Itinerario Alternativo</mat-panel-title>
                </mat-expansion-panel-header>

                <app-add-subroute-itinerary-modal [currentCreateSubRouteItinerary]="currentCreateSubRouteItinerary"
                  [daysList]="daysList" [actions]="actionsItinerary" [data]="data"
                  (saveItinerary)="save()"></app-add-subroute-itinerary-modal>

              </mat-expansion-panel>
            </mat-accordion>

            <table mat-table [dataSource]="currentUpdateSubRoute.alternaviteItinerary"
              class="min-w-500 overflow-y-visible mat-elevation-z">
              <ng-container matColumnDef="days">
                <th mat-header-cell *matHeaderCellDef>Días</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <mat-select [(ngModel)]="element.days[0]" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                      <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  } @else{
                  {{ getDayNames(element.days) }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Accion</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <mat-select [(ngModel)]="element.action" multiple aria-label="Accion"
                      [ngModelOptions]="{standalone: true}">
                      <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                        {{action | transloco }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  } @else {
                  {{ element.action | transloco }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="datetimeStart">
                <th mat-header-cell *matHeaderCellDef>Desde</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerStartE" [(ngModel)]="element.datetimeStart"
                      [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerStartE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStartE></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  {{element?.datetimeStart | FormatDateHour: false }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="datetimeEnd">
                <th mat-header-cell *matHeaderCellDef>Hasta</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerEndE" [(ngModel)]="element.datetimeEnd"
                      [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerEndE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEndE></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  {{element?.datetimeEnd | FormatDateHour: false }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                  @if (element.isEditMode) {
                  <mat-slide-toggle [checked]="element.statusId === 1"
                    [disabled]="!(PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE | hasPermission)"
                    (change)="onStatusChangeItinerary($event.checked, element)" color="primary">
                  </mat-slide-toggle>
                  }@else{
                  <mat-slide-toggle [checked]="element.statusId === 1"
                    [disabled]="!(PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE | hasPermission)"
                    (change)="onalternaviteItineraryStatusChange($event.checked, element)" color="primary">
                  </mat-slide-toggle>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  @if(isAddingItineraryAlternative){
                  <button *canPermissionsOnly="PERMISSIONS_ITINERARY_ALTERNATIVE.CREATE" color="primary" mat-button (click)="addItinerary(2)"
                    matTooltip="Asignar Itinerario Alternativo"><!--openAddItineraryModal(existingData, 2)-->
                    <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    <span></span>
                  </button>
                  }
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-icon-button (click)="onUpdateItinerary(element, i)" *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (!element.isEditMode)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    </button>
                    <button mat-icon-button (click)="onSaveItinerary(element, 2)"
                      *ngIf="(PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE | hasPermission) && (element.isEditMode)"><!--openAddItineraryModal(element, 2)-->
                      <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                    </button>
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY_ALTERNATIVE.DELETE" mat-icon-button (click)="openDeleteItineraryAlternative(element)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsI"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsI"></tr>
            </table>
            <!-- Paginación -->
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    </mat-dialog-actions>
  </ng-template>

  <!-- Routing itinerary modal  -->
  <ng-template #routingItineraryModal>
    <mat-dialog-content>
      <div class="text-2xl text-gray-700 text-center" style="font-weight: bold;">
        <span *ngIf="getCode(this.currentUpdateSubRoute) as code">
          <b>{{ code }} - </b>
        </span>
        {{ this.currentUpdateSubRoute.name }}
      </div>
      <mat-tab-group>
        <mat-tab label="Itinerario">
          <div>
            <!--<mat-accordion>
              <mat-expansion-panel [(expanded)]="isAddingItinerary">
                <mat-expansion-panel-header>
                  <mat-panel-title>Agregar Itinerario</mat-panel-title>
                </mat-expansion-panel-header>

                <app-add-subroute-itinerary-modal
                  [currentCreateSubRouteItinerary]="currentCreateRoutingItinerary"
                  [daysList]="daysList"
                  [actions]="actionsItinerary"
                  [data]="data"
                  (saveItinerary)="save()"
                ></app-add-subroute-itinerary-modal>

              </mat-expansion-panel>
            </mat-accordion>-->
            <table mat-table [dataSource]="dataSourceItinerary"
              class="min-w-500 overflow-y-visible mat-elevation-z table-fixed" multiTemplateDataRows>

              <ng-container matColumnDef="det">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="toggleDetails(element)"
                    style="margin-left: 10px;">
                    <mat-icon class="icon-size-5" [svgIcon]="selectedItinerary?._id === element._id
                              ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="datetimeStart">
                <th mat-header-cell *matHeaderCellDef>Desde</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerStartE" [(ngModel)]="element.dateTimeStart"
                      [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerStartE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStartE></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  {{element?.dateTimeStart | FormatDateHour: false }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="datetimeEnd">
                <th mat-header-cell *matHeaderCellDef>Hasta</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerEndE" [(ngModel)]="element.dateTimeEnd"
                      [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerEndE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEndE></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  {{element?.dateTimeEnd | FormatDateHour: false }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                  @if (element.isEditMode) {
                  <mat-slide-toggle [checked]="element.statusId === 1"
                    [disabled]="!(PERMISSIONS_ITINERARY.UPDATE | hasPermission)"
                    (change)="onStatusChangeItinerary($event.checked, element)" color="primary">
                  </mat-slide-toggle>
                  }@else{
                  <mat-slide-toggle [checked]="element.statusId === 1"
                    [disabled]="!(PERMISSIONS_ITINERARY.UPDATE | hasPermission)"
                    (change)="onitineraryStatusChange($event.checked, element)" color="primary">
                  </mat-slide-toggle>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="button-container">
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY.CREATE" color="primary" mat-button (click)="addItinerary(1)" matTooltip="Asignar Itinerario">
                      <!--//openAddItineraryModal(existingData, 1)"-->
                      <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                      <span></span>
                    </button>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div class="button-container">
                    <button mat-icon-button (click)="onUpdateItinerary(element, i, i)" *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (!element.isEditMode)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    </button>
                    <button mat-icon-button (click)="onSaveItinerary(element, 1, i)"
                      *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (element.isEditMode)"><!--openAddItineraryModal(element, 1)-->
                      <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                    </button>
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY.DELETE" mat-icon-button (click)="openDeleteItinerary(element, 1)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsI2.length">
                  <tr *ngIf="selectedItinerary?._id === element._id" class="details-row">
                    <td [attr.colspan]="displayedColumnsI2.length">
                      <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
                    </td>
                  </tr>

              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsI2"></tr>
              <tr mat-row *matRowDef="let element; columns: displayedColumnsI2"
                [class.table-expanded-row]="selectedItinerary?._id === element._id"></tr>
              <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="table-detail-row"></tr>
            </table>
            <!-- Paginación -->
          </div>
          <ng-template #rowDetailsTemplate let-order>
            <div class="w-full">
              <table class="w-full">
                <thead>
                  <tr>
                    <th class="w-1/12">#</th>
                    <th class="w-4/12">Días</th>
                    <th class="w-6/12">Acciones</th>
                    <th class="w-1/12">
                      <div class="button-container padding-button-container">
                        <ng-container *ngIf="!openFormAddRoutingItineraryDetail">
                          <button *canPermissionsOnly="PERMISSIONS_ITINERARY.UPDATE" mat-icon-button color="primary"
                            (click)="openFormAddRoutingItineraryDetail = true" matTooltip="Nuevo Registro">
                            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                            <span></span>
                          </button>
                        </ng-container>
                        <button *ngIf="openFormAddRoutingItineraryDetail" mat-icon-button color="primary"
                          (click)="openFormAddRoutingItineraryDetail = false;" matTooltip="Cerrar">
                          <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                        </button>

                        <button mat-icon-button color="primary" matTooltip="Editar" (click)="onUpdateDetailItinerary()"
                          *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (!editDetailRoutingItineraryDetail)">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button color="primary" matTooltip="Guardar" (click)="onSaveDetailItinerary(1)"
                          *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (editDetailRoutingItineraryDetail)">
                          <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                        </button>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="openFormAddRoutingItineraryDetail == true"
                    style=" background: rgba(197, 191, 191, 0.2); border-radius: 12px;">
                    <td></td>
                    <td>
                      <div class="mr-2">
                        <mat-form-field class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                          <mat-select [(ngModel)]="currentCreateRoutingItineraryDay" aria-label="Accion"
                            [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                    </td>
                    <td>
                      <mat-form-field class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                        <mat-select [value]="currentCreateRoutingItineraryActions" multiple aria-label="Accion"
                          [ngModelOptions]="{ standalone: true }" (selectionChange)="onActionSelectionChange($event)">

                          <mat-select-trigger>
                            <div cdkDropList [cdkDropListData]="currentCreateRoutingItineraryActions"
                              class="flex flex-wrap gap-1" (cdkDropListDropped)="dropAction($event)">
                              <mat-chip *ngFor="let selected of currentCreateRoutingItineraryActions" cdkDrag
                                [removable]="true" class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                                (removed)="removeAction(selected)">
                                {{ selected | transloco }}
                                <button matChipRemove class="ml-0 p-0">
                                  <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                                </button>
                              </mat-chip>
                            </div>
                          </mat-select-trigger>

                          <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                            {{ action | transloco }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <div class="button-container padding-button-container">
                        <button *canPermissionsOnly="PERMISSIONS_ITINERARY.UPDATE" color="primary" mat-icon-button (click)="onAddToListRoutingItinerary(1)">
                          <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngFor="let item of listItineraryDetail; let i = index">
                    <td valign="center">{{(i+1)}}</td>
                    <td>
                      @if (editDetailRoutingItineraryDetail) {
                      <div class="mr-2">
                        <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                          <mat-select [(ngModel)]="item.day" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      } @else{
                      <div class="w-full mt-4 mb-4">
                        {{ getDayNames(item.day) }}
                      </div>
                      }
                    </td>
                    <td>
                      @if (editDetailRoutingItineraryDetail) {
                      <div class="mx-1">
                        <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                          <mat-select [value]="item.action" multiple aria-label="Accion"
                            [ngModelOptions]="{ standalone: true }"
                            (selectionChange)="onActionSelectionChange($event, item)">

                            <mat-select-trigger>
                              <div cdkDropList [cdkDropListData]="item.action" class="flex flex-wrap gap-1"
                                (cdkDropListDropped)="dropAction($event, item)">
                                <mat-chip *ngFor="let selected of item.action" cdkDrag [removable]="true"
                                  class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                                  (removed)="removeAction(selected, item)">
                                  {{ selected | transloco }}
                                  <button matChipRemove class="ml-0 p-0">
                                    <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                                  </button>
                                </mat-chip>
                              </div>
                            </mat-select-trigger>

                            <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                              {{ action | transloco }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      } @else {
                      {{ item.action | transloco }}
                      }
                    </td>
                    <td>
                      <div class="button-container padding-button-container">
                        <!--
                        <button mat-icon-button (click)="onUpdateDetailItinerary(item, i, i)" *ngIf="!item.isEditMode">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button (click)="onSaveDetailItinerary(item, i, i)" *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (item.isEditMode)">
                            <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                        </button>
                        -->
                        <button mat-icon-button matTooltip="Borrar" (click)="openDeleteDetailItinerary(item, i, i)"
                          *ngIf="(PERMISSIONS_ITINERARY.DELETE | hasPermission) && (editDetailRoutingItineraryDetail)">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!--
            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceItineraryDetail" matSort>
              <ng-container matColumnDef="days">
                <th mat-header-cell *matHeaderCellDef>Días</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                    <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                      <mat-select [(ngModel)]="element.day" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  } @else{
                    {{ getDayNames(element.day) }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Acción</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                    <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                      <mat-select
                        [value]="element.action"
                        multiple
                        aria-label="Accion"
                        [ngModelOptions]="{ standalone: true }"
                        (selectionChange)="onActionSelectionChange($event, element)">
                    
                        <mat-select-trigger>
                          <div
                            cdkDropList
                            [cdkDropListData]="element.action"
                            class="flex flex-wrap gap-1"
                            (cdkDropListDropped)="dropAction($event, element)">
                            <mat-chip
                              *ngFor="let selected of element.action"
                              cdkDrag
                              [removable]="true"
                              class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                              (removed)="removeAction(element, selected)">
                              {{ selected | transloco }}
                              <button matChipRemove class="ml-0 p-0">
                                <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                              </button>
                            </mat-chip>
                          </div>
                        </mat-select-trigger>
                    
                        <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                          {{ action | transloco }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  } @else {
                    {{ element.action | transloco }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  @if(isAddingItinerary){
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY.CREATE"
                    color = "primary"
                    mat-button
                    (click)="addItinerary(1)"
                    matTooltip="Asignar Itinerario"
                    > 
                      <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                      <span></span>
                    </button>
                  }
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div class="button-container">
                    <button mat-icon-button (click)="onUpdateItinerary(element, i, i)" *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (!element.isEditMode)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    </button>
                    <button mat-icon-button (click)="onSaveItinerary(element, 1, i)" *ngIf="(PERMISSIONS_ITINERARY.UPDATE | hasPermission) && (element.isEditMode)">
                        <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                    </button>
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY.DELETE" mat-icon-button (click)="openDeleteItinerary(element)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsID2" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsID2;" class="border-b"></tr>
            
            </table>
            -->


          </ng-template>
        </mat-tab>
        <mat-tab label="Itinerario Alternativo">
          <div>
            <!--<mat-accordion>
              <mat-expansion-panel [(expanded)]="isAddingItineraryAlternative">
                <mat-expansion-panel-header>
                  <mat-panel-title>Agregar Itinerario Alternativo</mat-panel-title>
                </mat-expansion-panel-header>

                <app-add-subroute-itinerary-modal
                  [currentCreateSubRouteItinerary]="currentCreateSubRouteItinerary"
                  [daysList]="daysList"
                  [actions]="actionsItinerary"
                  [data]="data"
                  (saveItinerary)="save()"
                ></app-add-subroute-itinerary-modal>

              </mat-expansion-panel>
            </mat-accordion>-->

            <table mat-table [dataSource]="dataSourceItineraryAlternative"
              class="min-w-500 overflow-y-visible mat-elevation-z table-fixed" multiTemplateDataRows>
              <ng-container matColumnDef="det">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="toggleDetailsAlternative(element)"
                    style="margin-left: 10px;">
                    <mat-icon class="icon-size-5" [svgIcon]="selectedItineraryAlternative?._id === element._id
                              ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="datetimeStart">
                <th mat-header-cell *matHeaderCellDef>Desde</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerStartE" [(ngModel)]="element.dateTimeStart"
                      [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerStartE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStartE></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  {{element?.dateTimeStart | FormatDateHour: false }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="datetimeEnd">
                <th mat-header-cell *matHeaderCellDef>Hasta</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.isEditMode) {
                  <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                    <input matInput [matDatepicker]="pickerEndE" [(ngModel)]="element.dateTimeEnd"
                      [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="pickerEndE"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEndE></mat-datepicker>
                  </mat-form-field>
                  }@else{
                  {{element?.dateTimeEnd | FormatDateHour: false }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element" class="px-6 text-left">
                  @if (element.isEditMode) {
                  <mat-slide-toggle [checked]="element.statusId === 1"
                    (change)="onStatusChangeItinerary($event.checked, element)" color="primary">
                  </mat-slide-toggle>
                  }@else{
                  <mat-slide-toggle [checked]="element.statusId === 1"
                    (change)="onitineraryAlternativeStatusChange($event.checked, element)" color="primary">
                  </mat-slide-toggle>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="button-container">
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY_ALTERNATIVE.CREATE" color="primary" mat-button (click)="addItinerary(2)" matTooltip="Asignar Itinerario">
                      <!--//openAddItineraryModal(existingData, 1)"-->
                      <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                      <span></span>
                    </button>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div class="button-container">
                    <button mat-icon-button (click)="onUpdateItinerary(element, i, i)" *ngIf="(PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE | hasPermission) && (!element.isEditMode)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    </button>
                    <button mat-icon-button (click)="onSaveItinerary(element, 2, i)"
                      *ngIf="(PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE | hasPermission) && (element.isEditMode)"><!--openAddItineraryModal(element, 1)-->
                      <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                    </button>
                    <button *canPermissionsOnly="PERMISSIONS_ITINERARY_ALTERNATIVE.DELETE" mat-icon-button (click)="openDeleteItinerary(element, 2)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsI2.length">
                  <tr *ngIf="selectedItineraryAlternative?._id === element._id" class="details-row">
                    <td [attr.colspan]="displayedColumnsI2.length">
                      <ng-container
                        *ngTemplateOutlet="rowDetailsAlternativeTemplate; context: { $implicit: row }"></ng-container>
                    </td>
                  </tr>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsI2"></tr>
              <tr mat-row *matRowDef="let element; columns: displayedColumnsI2"
                [class.table-expanded-row]="selectedItineraryAlternative?._id === element._id"></tr>
              <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="table-detail-row"></tr>
            </table>
            <!-- Paginación -->
          </div>

          <ng-template #rowDetailsAlternativeTemplate let-order>
            <div class="w-full">
              <table class="w-full">
                <thead>
                  <tr>
                    <th class="w-1/12">#</th>
                    <th class="w-4/12">Días</th>
                    <th class="w-6/12">Acciones</th>
                    <th class="w-1/12">
                      <div class="button-container padding-button-container">
                        <ng-container *ngIf="!openFormAddRoutingItineraryAlternativeDetail">
                          <button *canPermissionsOnly="PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE" mat-icon-button color="primary"
                            (click)="openFormAddRoutingItineraryAlternativeDetail = true" matTooltip="Nuevo Registro">
                            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                            <span></span>
                          </button>
                        </ng-container>
                        <ng-container *ngIf="openFormAddRoutingItineraryAlternativeDetail">
                          <button *canPermissionsOnly="PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE" mat-icon-button color="primary"
                            (click)="openFormAddRoutingItineraryAlternativeDetail = false;" matTooltip="Cerrar">
                            <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                          </button>
                        </ng-container>

                        <button mat-icon-button color="primary" matTooltip="Editar"
                          (click)="onUpdateDetailItineraryAlternative()"
                          *ngIf="(PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE | hasPermission) && (!editDetailRoutingItineraryAlternativeDetail)">
                          <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                        </button>
                        <button mat-icon-button color="primary" matTooltip="Guardar" (click)="onSaveDetailItinerary(2)"
                          *ngIf="(PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE | hasPermission) && (editDetailRoutingItineraryAlternativeDetail)">
                          <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                        </button>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="openFormAddRoutingItineraryAlternativeDetail == true"
                    style=" background: rgba(197, 191, 191, 0.2); border-radius: 12px;">
                    <td></td>
                    <td>
                      <div class="mr-2">
                        <mat-form-field class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                          <mat-select [(ngModel)]="currentCreateRoutingItineraryAlternativeDay" aria-label="Accion"
                            [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                    </td>
                    <td>
                      <mat-form-field class="w-full mt-2 mb-2" appearance="fill" floatLabel="never">
                        <mat-select [value]="currentCreateRoutingItineraryAlternativeActions" multiple
                          aria-label="Accion" [ngModelOptions]="{ standalone: true }"
                          (selectionChange)="onActionAlternativeSelectionChange($event)">

                          <mat-select-trigger>
                            <div cdkDropList [cdkDropListData]="currentCreateRoutingItineraryAlternativeActions"
                              class="flex flex-wrap gap-1" (cdkDropListDropped)="dropActionAlternative($event)">
                              <mat-chip *ngFor="let selected of currentCreateRoutingItineraryAlternativeActions" cdkDrag
                                [removable]="true" class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                                (removed)="removeActionAlternative(selected)">
                                {{ selected | transloco }}
                                <button matChipRemove class="ml-0 p-0">
                                  <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                                </button>
                              </mat-chip>
                            </div>
                          </mat-select-trigger>

                          <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                            {{ action | transloco }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <div class="button-container padding-button-container">
                        <button *canPermissionsOnly="PERMISSIONS_ITINERARY_ALTERNATIVE.UPDATE" color="primary" mat-icon-button (click)="onAddToListRoutingItinerary(2)">
                          <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngFor="let item of listItineraryAlternativeDetail; let i = index">
                    <td valign="center">{{(i+1)}}</td>
                    <td>
                      @if (editDetailRoutingItineraryAlternativeDetail) {
                      <div class="mr-2">
                        <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                          <mat-select [(ngModel)]="item.day" aria-label="Accion" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let day of daysList" [value]="day.value">{{ day.day }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      } @else{
                      <div class="w-full mt-4 mb-4">
                        {{ getDayNames(item.day) }}
                      </div>
                      }
                    </td>
                    <td>
                      @if (editDetailRoutingItineraryAlternativeDetail) {
                      <div class="mx-1">
                        <mat-form-field class="w-full mt-2" appearance="fill" floatLabel="never">
                          <mat-select [value]="item.action" multiple aria-label="Accion"
                            [ngModelOptions]="{ standalone: true }"
                            (selectionChange)="onActionSelectionChange($event, item)">

                            <mat-select-trigger>
                              <div cdkDropList [cdkDropListData]="item.action" class="flex flex-wrap gap-1"
                                (cdkDropListDropped)="dropAction($event, item)">
                                <mat-chip *ngFor="let selected of item.action" cdkDrag [removable]="true"
                                  class="text-xs px-0 py-0 h-5 min-h-0 leading-none gap-1"
                                  (removed)="removeAction(selected, item)">
                                  {{ selected | transloco }}
                                  <button matChipRemove class="ml-0 p-0">
                                    <mat-icon class="text-[12px] leading-none">cancel</mat-icon>
                                  </button>
                                </mat-chip>
                              </div>
                            </mat-select-trigger>

                            <mat-option *ngFor="let action of actionsItinerary" [value]="action">
                              {{ action | transloco }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      } @else {
                      {{ item.action | transloco }}
                      }
                    </td>
                    <td>
                      <div class="button-container padding-button-container">
                        <button mat-icon-button matTooltip="Borrar"
                          (click)="openDeleteDetailItineraryAlternative(item, i, i)"
                          *ngIf="(PERMISSIONS_ITINERARY_ALTERNATIVE.DELETE | hasPermission) && (editDetailRoutingItineraryAlternativeDetail)">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>

        </mat-tab>
      </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    </mat-dialog-actions>
  </ng-template>

  <!-- Modal Horario(s) de Entrega  -->
  <ng-template #addModalOrder>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">
      Vnas. Horarias de Entrega
    </h2>
    <mat-dialog-content class="modal-content">
      <div class="flex justify-end mb-2">
        <button *canPermissionsOnly="PERMISSIONS_DELIVERY_WINDOWS.CREATE" mat-button (click)="openAddOrderModal()" matTooltip="Asignar Horario">
          <mat-icon svgIcon="heroicons_outline:plus-circle"></mat-icon>
          <span></span>
        </button>
      </div>
      <!-- Tabla de Horario(s) de Entrega -->
      <div>
        <table mat-table [dataSource]="currentUpdateSubRoute.orderDeliveryWindows"
          class="min-w-500 overflow-y-visible mat-elevation-z">
          <ng-container matColumnDef="days">
            <th mat-header-cell *matHeaderCellDef>Días</th>
            <td mat-cell *matCellDef="let element">
              {{ getDayNames(element.days) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="hourStart">
            <th mat-header-cell *matHeaderCellDef>Hora de Inicio</th>
            <td mat-cell *matCellDef="let element">
              {{ element.hourStart }}
            </td>
          </ng-container>

          <ng-container matColumnDef="hourEnd">
            <th mat-header-cell *matHeaderCellDef>Hora Fin</th>
            <td mat-cell *matCellDef="let element">
              {{ element.hourEnd }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element">
              {{ element.statusId }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div class="button-container">
                <button *canPermissionsOnly="PERMISSIONS_DELIVERY_WINDOWS.DELETE" mat-icon-button (click)="openDeleteOrder(element)">
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
                <button *canPermissionsOnly="PERMISSIONS_DELIVERY_WINDOWS.UPDATE" mat-icon-button (click)="openAddOrderModal(element)">
                  <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsO"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsO"></tr>
        </table>
        <!-- Paginación -->
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-right">Aceptar</button>
    </mat-dialog-actions>
  </ng-template>

  <!-- Default Value -->
  <ng-template #defaultRow>
    -
  </ng-template>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true" [loadData]="loadFiltersData"></app-configuration-filters>
    <app-routes-filters [form]="form" [territory]="true" [areaRoute]="true" [routeGroup]="true" [function]="true" [loadData]="loadFiltersData"></app-routes-filters>
    <app-business-partners-filters [form]="form"
      [assignedUserByBusinessPartnerName]="true" [loadData]="loadFiltersData"></app-business-partners-filters>
  </app-filter>
</mat-sidenav-container>
